//export const API_URL = 'https://api.brn.ai';
//export const API_URL = 'http://localhost:3251';
export const API_URL = 'https://api-stage.brn.ai';

// Add other constants here as needed
export const APP_NAME = 'Stitch App';
export const VERSION = '1.0.0';

// Shopify OAuth Configuration
export const SHOPIFY_CLIENT_ID = '943c7a6eb3a3ee972b91777678fc9559';
export const SHOPIFY_SCOPE = 'read_products,read_orders,read_customers'; 
export const APP_URL = window.location.origin;
export const REDIRECT_URI = `${APP_URL}/authorize/shopify`; 

// Slack OAuth Configuration
export const SLACK_CLIENT_ID = '9152129474641.9137795470805';
export const SLACK_SCOPE = 'users:read,channels:history,chat:write,channels:read,commands,groups:read,files:read,files:write,im:history,im:read,im:write,emoji:read,links.embed:write,links:read,dnd:read,metadata.message:read,reactions:read,reactions:write,incoming-webhook,remote_files:write';
export const SLACK_REDIRECT_URI = `${APP_URL}/authorize/slack`; 

// Facebook OAuth Configuration
export const FACEBOOK_APP_ID = '279474245766642';
export const FACEBOOK_SCOPE = 'ads_read';

// Google Ads OAuth Configuration
export const GOOGLE_ADS_REDIRECT_URI = `${APP_URL}/auth/google-ads`;